<template>
 <b-modal @close="onClose()" :active="isActive">
  <div class="box">
   <h1>search for your icons</h1>
   <b-icon v-for="iconName in icons" v-bind:key="iconName"
      pack="fab"
      class="interactive"
      :icon="iconName"
      type="is-primary"
      size="is-large"
      @click.native="selectIcon(iconName)">
    </b-icon>
  </div>
 </b-modal>
</template>

<script>
import {mapActions} from 'vuex'
  export default {
    name: 'IconSearchModal',
    props: {
      isActive:{
        type:Boolean,
        required:true,
        default:false
      },
      link: Object,
    },
    data() {
      return {
        icons:[
          "facebook",
          "whatsapp",
          "tiktok",
          "youtube",
          "instagram",
          "github",
          "gitlab",
          "tumblr",
          "twitter",
          "reddit",
          "linkedin",
          "snapchat",
          "pinterest",
          "telegram",
          "behance",
          "medium",
          "amazon",
          "spotify",
          "soundcloud",
          "airbnb",
          "google-play",
          "app-store",
        ]
        
      }
    },
    methods: {
      ...mapActions(['saveLinkChange']),
      onClose(){
        this.$emit("close")
      },
      selectIcon(iconName){
        this.link.icon = iconName;
        this.saveLinkChange()
        this.$emit("close")
      }
    },
    mounted() {
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .m-t-20px {
    margin-top: 20px;
  }

  .m-r-20px {
    margin-right: 20px;
  }

  .vertical {
    height: 100%;
    width: -webkit-fill-available;
    padding: 10px 20px;
  }

  .field {
    margin: 15px 0;
  }

  .cent-vet {
    margin: auto 0;
  }

  .gripper {
    margin: auto 8px;

    &:hover {
      cursor: move;
    }
  }
</style>